var _defs, _path, _path2, _polyline, _polyline2, _polyline3, _path3, _polyline4, _line, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3 {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m595.1,202.36l-29.1,50.4h-232.79l-50.05,84.97h-64.02s68.72-119.03,72.58-125.71c.42,0,.75,0,.75,0h232.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m595.1,202.71l-40.74-40.74-.05-.05c-2.13,3.46-29.05,50.1-29.05,50.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "304.53 605.86 263.37 564.7 321.57 564.7 586.95 299.32 475.21 492.54"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "475.21 492.54 362.31 605.44 304.11 605.44"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "765.45 203.13 724.3 161.97 570.66 427.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m433.31,564.7h58.2l265.38-265.38-111.74,193.22-112.9,112.9h-58.2c-4.26-4.26-40.74-40.74-40.74-40.74"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "765.04 202.71 723.14 274.88 570.66 427.36"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 894.24,
    y1: 161.97,
    x2: 935.39,
    y2: 203.13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m894.24,161.97l-232.79,402.73h-58.2l40.74,40.74h58.2l232.79-402.73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1077.56,337.38l-29.1,50.4s-104.82,0-115.52.01l-.29.5-101.85,176.4h-58.2s36.44,36.44,40.74,40.74h58.2l101.85-176.4.29-.5c10.7-.01,115.52-.01,115.52-.01l29.1-50.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1077.56,337.73l40.74,40.74-40.74-40.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1296.39,161.62l-29.1,50.4h-232.79s-.33,0-.75,0c-3.85,6.68-72.58,125.71-72.58,125.71h64.02l50.05-84.97h232.79s26.92-46.63,28.98-50.19c-2.49-2.48-40.61-40.6-40.61-40.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m334.96,337.38l-29.1,50.4s-104.82,0-115.52.01l-.29.5-101.85,176.4H30s36.44,36.44,40.74,40.74h58.2l101.85-176.4.29-.5c10.7-.01,115.52-.01,115.52-.01l29.1-50.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m334.96,337.73l40.74,40.74-40.74-40.74Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m553.78,161.62l-29.1,50.4h-232.79s-.33,0-.75,0c-3.85,6.68-72.58,125.71-72.58,125.71h64.02l50.05-84.97h232.79s26.92-46.63,28.98-50.19c-2.49-2.48-40.61-40.6-40.61-40.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmf);
export default __webpack_public_path__ + "static/media/fmf.008cbff7a37ebbda21238ad2766102ca.svg";
export { ForwardRef as ReactComponent };